import { render, staticRenderFns } from "./GameStartSound.vue?vue&type=template&id=584eabe2&"
import script from "./GameStartSound.vue?vue&type=script&lang=js&"
export * from "./GameStartSound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584eabe2')) {
      api.createRecord('584eabe2', component.options)
    } else {
      api.reload('584eabe2', component.options)
    }
    module.hot.accept("./GameStartSound.vue?vue&type=template&id=584eabe2&", function () {
      api.rerender('584eabe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameStartSound.vue"
export default component.exports